import { useContext } from 'react'
import PagamentoContext from 'src/contexts/Pagamento/context'

const usePagamento = () => {
  const pagamento = useContext(PagamentoContext)
  return pagamento
}

export default usePagamento
